import { ApiError } from '../types/api';

/**
 * Shown when the backend answers `429 { error: 'totp_locked' }`: five wrong
 * TOTP/recovery codes (login or step-up) lock the account for 15 minutes
 * and revoke its sessions (security fix 2026-09-25, docs/decisions.md
 * "Sikkerhedsrettelser 25/9").
 */
export const TOTP_LOCKED_MESSAGE =
  'Too many incorrect codes. The account is locked for 15 minutes.';

export function isTotpLocked(err: unknown): boolean {
  return err instanceof ApiError && err.status === 429 && err.body.error === 'totp_locked';
}
